import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

const COLORS = ['#3b82f6', '#22c55e', '#f59e0b', '#ef4444'];

const TimeSeriesChart = ({ data, bars, lines, height }) => (
  <div className="o-chart-container">
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="date" tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 12 }} />
        <Tooltip />
        <Legend />
        {bars && bars.map((bar, i) => (
          <Bar
            key={bar.dataKey}
            dataKey={bar.dataKey}
            name={bar.name}
            fill={COLORS[i % COLORS.length]}
            radius={[2, 2, 0, 0]}
          />
        ))}
        {lines && lines.map((line, i) => (
          <Line
            key={line.dataKey}
            dataKey={line.dataKey}
            name={line.name}
            stroke={COLORS[((bars ? bars.length : 0) + i) % COLORS.length]}
            strokeWidth={2}
            dot={false}
          />
        ))}
      </ComposedChart>
    </ResponsiveContainer>
  </div>
);

TimeSeriesChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  bars: PropTypes.arrayOf(
    PropTypes.shape({ dataKey: PropTypes.string.isRequired, name: PropTypes.string.isRequired })
  ),
  lines: PropTypes.arrayOf(
    PropTypes.shape({ dataKey: PropTypes.string.isRequired, name: PropTypes.string.isRequired })
  ),
  height: PropTypes.number,
};

TimeSeriesChart.defaultProps = {
  height: 300,
};

export default TimeSeriesChart;
